import { useCallback, useEffect, useState } from 'react'

import useFetchMetadata from '@/utils/fetchMetadata'

export const urlRegex = /(https?:\/\/[^\s]+)/g

export const useGetMetaData = () => {
  const [metadata, setMetadata] = useState(null)
  const [url, setUrl] = useState('')
  const { fetchMetadata, loading: isLoadingMeta } = useFetchMetadata()

  const handleGetMeta = useCallback(
    async (content: string) => {
      const matchedUrls = content?.match(urlRegex)
      if (matchedUrls?.length) {
        const metaUrl = await fetchMetadata(matchedUrls?.at(-1) as string)
        return metaUrl
      }
      return null
    },
    [fetchMetadata],
  )

  const handleGetLink = (content: string) => {
    const matchedUrls = content?.match(urlRegex)
    if (matchedUrls?.length) {
      setUrl(matchedUrls?.at(-1) as string)
    } else {
      setUrl('')
    }
  }

  useEffect(() => {
    const getMeta = async () => {
      if (!url) return
      const metaUrl = await fetchMetadata(url)
      setMetadata(metaUrl || null)
    }

    getMeta()
  }, [url])
  return { loading: isLoadingMeta, metadata, handleGetMeta, handleGetLink }
}
